import Vue from "vue";

export function truncate(data, num) {
  return data.split("").slice(0, num).join("") + "...";
}

Vue.filter('truncate', truncate)
